import { useState } from 'react';
import type { User } from '../../shared/api';

function initials(user: User): string {
  const source = user.name ?? user.email;
  return source
    .split(/[\s@.]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => Array.from(part)[0]!.toUpperCase())
    .join('');
}

/** A user's Google profile picture, or their initials if there isn't one (or it fails to load). */
export function Avatar({ user, className }: { user: User; className: string }) {
  const [pictureFailed, setPictureFailed] = useState(false);
  return user.pictureUrl && !pictureFailed ? (
    <img src={user.pictureUrl} alt="" className={className} onError={() => setPictureFailed(true)} />
  ) : (
    <span className={`${className} ${className}--initials`}>{initials(user)}</span>
  );
}
